/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { DashboardFilters } from '../../../../components/UI/Dashboard'
import { getTopUsers } from '../../../../store/dashboard/actions'
import '../../index.scss'
import DashboardNavigation from '../DashboardNavigation'
import QuizSubmissions from '../partials/QuizSubmissions/QuizSubmissions'
import QuizSummary from '../partials/QuizSummary/QuizSummary'

import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

const DashboardQuizzes = () => {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const [filtersData, setFiltersData] = useState({
    // type: 'daily',
    filter_from_date: null,
    filter_to_date: null,
    channel: null,
  })
  const [loading, setLoading] = useState(false)

  const hasFilterUpdated = async (e: any) => {
    await setFiltersData(e)
  }

  useEffect(() => {
    if (
      loading ||
      !(filtersData.filter_from_date || filtersData.filter_to_date)
    ) {
      return
    }

    fun()
  }, [filtersData])

  const fun = async () => {
    await setLoading(true)
    try {
      const topUsersData: any = await dispatch(
        getTopUsers(filtersData, 1, 100000),
      )
      const avgUsageDuration: any = []
      topUsersData.rows.forEach((d: any) => {
        avgUsageDuration.push({
          x: dayjs(new Date(d.last_active)).format('YYYY-MM-DD'),
          y: d.average_duration.toFixed(2),
        })
      })
      await setLoading(false)
    } catch (e: any) {
      await setLoading(false)
    }
  }

  return (
    <section className="dashborad-wraper">
      <DashboardFilters hasFilterUpdated={hasFilterUpdated} />
      <DashboardNavigation />

      <div className="tw-pt-4 tw-flex tw-flex-col tw-gap-4">
        <h2>{t('Quizzes')}</h2>

        <QuizSubmissions filtersData={filtersData} />
        <QuizSummary filtersData={filtersData} />
      </div>
    </section>
  )
}
export default DashboardQuizzes
